import { inject, InjectionToken } from '@angular/core';
import { PartnerMarketingService } from './partner-marketing.service';

/** Методы статистики, которые используют вкладки маркетинга (ссылка, промокоды, вознаграждение) */
export type MarketingApi = Pick<
  PartnerMarketingService,
  | 'getReferralLink'
  | 'createReferralLink'
  | 'getReferralSummary'
  | 'getReferralClicks'
  | 'getReferralPurchases'
  | 'getReferralPurchase'
  | 'getReferralRefunds'
  | 'getPromoCodes'
  | 'getPromoCodeSummary'
  | 'getPromoCodePurchases'
  | 'getPromoCodeRefunds'
  | 'getRewardSummary'
>;

/**
 * Источник данных для вкладок маркетинга.
 * По умолчанию — админские методы по partnerId; кабинет агента подменяет его на AgentMarketingService.
 */
export const MARKETING_API = new InjectionToken<MarketingApi>('MARKETING_API', {
  providedIn: 'root',
  factory: () => inject(PartnerMarketingService),
});
